"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListActions = void 0;
var actions_1 = require("../actions");
var FilterableListActions = /** @class */ (function () {
    function FilterableListActions() {
    }
    FilterableListActions.CHANGE = 'FILTER_CHANGE';
    FilterableListActions.RESET = 'FILTER_RESET';
    FilterableListActions.RESET_TAB_FILTERS = 'FILTER_TAB_RESET';
    FilterableListActions.CANCEL = 'FILTER_CANCEL';
    FilterableListActions.QUERY_CHANGE = 'FILTER_QUERY_CHANGE';
    FilterableListActions.SORT_CHANGE = 'FILTER_SORT_CHANGE';
    FilterableListActions.PAGE_CHANGE = 'FILTER_PAGE_CHANGE';
    FilterableListActions.PAGE_SIZE_CHANGE = 'FILTER_PAGE_SIZE_CHANGE';
    FilterableListActions.change = function (groupValue, filterValue, unSelect, isSub) {
        if (unSelect === void 0) { unSelect = false; }
        if (isSub === void 0) { isSub = false; }
        return actions_1.createAction(FilterableListActions.CHANGE, {
            filterValue: filterValue,
            groupValue: groupValue,
            unSelect: unSelect,
            isSub: isSub,
        });
    };
    FilterableListActions.reset = function () {
        return actions_1.createAction(FilterableListActions.RESET, undefined);
    };
    FilterableListActions.resetTabFilters = function () {
        return actions_1.createAction(FilterableListActions.RESET_TAB_FILTERS, undefined);
    };
    FilterableListActions.cancel = function (previousSelectedFilters) {
        return actions_1.createAction(FilterableListActions.CANCEL, previousSelectedFilters);
    };
    FilterableListActions.pageChange = function (pageNumber, filterChanged) {
        if (filterChanged === void 0) { filterChanged = false; }
        return actions_1.createAction(FilterableListActions.PAGE_CHANGE, {
            pageNumber: pageNumber,
            filterChanged: filterChanged,
        });
    };
    FilterableListActions.pageSizeChange = function (pageSize, filterChanged) {
        if (filterChanged === void 0) { filterChanged = false; }
        return actions_1.createAction(FilterableListActions.PAGE_SIZE_CHANGE, {
            pageSize: pageSize,
            filterChanged: filterChanged,
        });
    };
    FilterableListActions.sortChange = function (sortBy) {
        return actions_1.createAction(FilterableListActions.SORT_CHANGE, sortBy);
    };
    FilterableListActions.queryChange = function (query, isInitialSearch) {
        return actions_1.createAction(FilterableListActions.QUERY_CHANGE, {
            query: query,
            isInitialSearch: isInitialSearch,
        });
    };
    return FilterableListActions;
}());
exports.FilterableListActions = FilterableListActions;
